import { BusinessEntityType } from "src/app/shared/enums/BusinessEntityType.enum"

export class CompanyDetails {
    public id: string;
    public clientDetailsId: number;
    public organizationDetailsId: number;
    public name: string;
    public entityType: BusinessEntityType;
}